<template>

<app-text>

	<app-message :error="true" v-if="is.errored">

		One or more fields are invalid. Please review and try again.

	</app-message>

    <app-group v-html="page.business_adverts_book_design_content" />

	<app-group>

		<app-input-text v-model="inputs.name" :errored="errored.name" :label="page.business_adverts_book_design_name_label" :placeholder="page.business_adverts_book_design_name_placeholder" />
        <app-input-toggle v-model="inputs.type" :errored="errored.type" :label="page.business_adverts_book_design_type_label" :options="options.type" />
        <app-input-image v-model="inputs.image" :hidePreview="true" :errored="errored.image" :label="page.business_adverts_book_design_image_label" :placeholder="page.business_adverts_book_design_image_placeholder" v-on:change="inputs.imageRaw = arguments[0]" />

    </app-group>

    <div class="design-preview">

        <div class="design-preview-banner" :class="{'is-large': inputs.type === 1, 'is-small': inputs.type === 2}" :style="{backgroundImage: previewImage}">

            <div class="design-preview-banner-text">
                
                <div class="design-preview-banner-text-header">{{ previewText }}</div>
                <div class="design-preview-banner-text-business">{{ session.business.name }}</div>

            </div>

        </div>

    </div>

	<app-group :row="true" :center="true">

		<app-button :text="page.business_adverts_book_design_button_proceed" :loading="is.submitting" :disabled="!is.valid" v-on:click="$emit('proceed', inputs)" />
		<app-button :text="page.business_adverts_book_design_button_cancel" theme="plain" v-on:click="$emit('back')" />

	</app-group>

</app-text>

</template>

<script>

import mixinForm from '@/mixin/form.js'

export default {

	mixins: [mixinForm],

	data: function() {

		return {
            options: {
                type: {
                    1: 'Large',
                    2: 'Small'
                }
            },
			inputs: {
				name: '',
                image: '',
                imageRaw: '',
                type: 1
			},
			rules: {
				name: {
					required: true
				},
				imageRaw: {
					required: true
				},
				type: {
					required: true
				}
			}
		}

    },

    created: function() {

        if (this.$route.meta.cancel) {

            var inputs = this.$store.getters['memory']['adverts/book'] || {}

            this.inputs.name = inputs.name 
            this.inputs.type = inputs.type 
            this.inputs.imageRaw = inputs.imageRaw
            
        }

    },
    
    computed: {

        previewText: function() {
            
            return (this.inputs.name) ? this.inputs.name : 'Untitled'

        },

        previewImage: function() {

            return (this.inputs.imageRaw) ? 'url(' + this.inputs.imageRaw + ')' : false

        }

    }

}

</script>

<style scoped>

.design-preview {
    width: 100%;
    border: 10px solid var(--color-grey-light);
    background-color: var(--color-grey-light);
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 20px;
}

.design-preview-banner {
    background-color: var(--color-blue-light);
    background-position: 50% 50%;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.design-preview-banner.is-large {
    width: 500px;
    height: 365px;
}

.design-preview-banner.is-small {
    width: 333px;
    height: 365px;
}

.is-mobile .design-preview-banner.is-large {
    width: 100%;
    height: 240px;
}

.is-mobile .design-preview-banner.is-small {
    width: 100%;
    height: 180px;
}

.design-preview-banner-text {
    padding: 20px;
    color: #fff;
    background: linear-gradient(180deg,transparent 0,rgba(0,0,0,.65));
}

.design-preview-banner-text-header {
    font-family: grueber,serif;
    font-size: 32px;
}

.design-preview-banner-text-business {
    font-size: 16px;
    font-weight: 500;
    display: block;
}

</style>